import { useState, useEffect } from "react";

export const useLogin = () => {
  const [loginDetails, setLoginDetails] = useState(() => {
    return JSON.parse(localStorage.getItem("loginData") || "null");
  });

  useEffect(() => {
    const storedData = localStorage.getItem("loginData");
    if (storedData) {
      setLoginDetails(JSON.parse(storedData));
    }
  }, []);

  return loginDetails;
};

export const clearLoginData = () => {
  localStorage.removeItem("loginData");
};
